import { css } from 'styled-components';

export default css`
  background-color: ${({ theme }) => theme.primaryColor};

  &:after {
    display: block;
  }
`;
